var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaningTaskFinishedType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.9,
    height: 19.9,
    viewBox: "0 0 19.9 19.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M2561.95,19.9a9.95,9.95,0,1,1,9.95-9.95A9.961,9.961,0,0,1,2561.95,19.9Zm0-18.336a8.386,8.386,0,1,0,8.386,8.386A8.4,8.4,0,0,0,2561.95,1.564ZM2566.6,6.69l-1.342-.966L2560.738,12l-2.615-1.5-.825,1.434,3.91,2.249Z",
    transform: "translate(-2552)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningTaskFinishedType);
export default __webpack_public_path__ + "static/media/cleaningTaskFinishedType.c11a4ea4.svg";
export { ForwardRef as ReactComponent };